export function newIdempotencyId(prefix = "id"): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return `${prefix}_${crypto.randomUUID()}`;
  }
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function parseConvexError(err: unknown): {
  name: string;
  message: string;
  currentRevision?: number;
  expectedRevision?: number;
  code?: string;
  field?: string;
} {
  const raw = err instanceof Error ? err.message : String(err);
  try {
    const parsed = JSON.parse(raw) as {
      name?: string;
      message?: string;
      currentRevision?: number;
      expectedRevision?: number;
      code?: string;
      field?: string;
    };
    if (parsed.message) {
      return {
        name: parsed.name ?? "Error",
        message: parsed.message,
        currentRevision: parsed.currentRevision,
        expectedRevision: parsed.expectedRevision,
        code: parsed.code,
        field: parsed.field,
      };
    }
  } catch {
    // not JSON
  }
  return { name: "Error", message: raw };
}

export function downloadTextFile(
  fileName: string,
  contents: string,
  mime = "text/csv;charset=utf-8",
) {
  const blob = new Blob([contents], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

export function columnKeyFromLabel(label: string): string {
  const base = label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return base || `col_${Date.now()}`;
}

export function formatRelativeTime(ts: number): string {
  const diff = Date.now() - ts;
  const sec = Math.round(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 48) return `${hr}h ago`;
  return new Date(ts).toLocaleString();
}
